import { ArrowRightLineIcon, Button } from 'ui';

type P = {
  onClick: () => void;
};

const ContinueInBrowserButton = ({ onClick }: P) => (
  <Button icon={<ArrowRightLineIcon />} iconPosition="end" onClick={onClick} size="large">
    Or, continue in browser
  </Button>
);

export default ContinueInBrowserButton;
